<template>
  <div class="code-release-flow-detail">
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'asset_scrap', query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <Card shadow>
      <div class="content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px" :gutter="16">
              <Col :xs="24" :sm="24" :md="24" :lg="19">
                <Row class="title">
                  <h4 :style="{float: 'left'}">报废流程申请工作流详情</h4>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>申请人</dt><dd v-if="info.applicant">{{ info.applicant.name ?
                    info.applicant.name : info.applicant.username }}</dd>
                  </dl>
                  <dl>
                    <dt>标题</dt><dd>{{ info.title }}</dd>
                  </dl>
                  <dl>
                    <dt>报废资产</dt>
                    <dd>
                      <Tag color="warning" v-for="item in info.assets" :key="item.id" @click.native="handleClick(item)">{{ item.asset_id }}</Tag>
                       <Alert type="warning" show-icon>点击可查看资产价值等更多信息</Alert>
                    </dd>
                  </dl>
                  <dl v-if="is_scrap_value_show">
                    <dt v-if="!is_scrap_value_disabled">残值(请选择)</dt>
                    <dt v-else>残值</dt>
                    <dd>
                      <RadioGroup v-model="info.scrap_value" @on-change="actionChange">
                        <Radio :label="'1'" border :disabled="is_scrap_value_disabled">小于10万元</Radio>
                        <Radio :label="'2'" border :disabled="is_scrap_value_disabled">大于10万元</Radio>
                      </RadioGroup>
                    </dd>
                  </dl>
                  <dl>
                    <dt>资产类型</dt>
                    <dd>
                       {{ info.type_name }}
                    </dd>
                  </dl>
                  <dl v-if="info.created_at">
                    <dt>申请时间</dt><dd>{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl style="margin-top: 15px">
                    <dt>操作</dt>
                    <dd>
                      <Approves :approves="info.approves" approveType="operate_release" :reFresh="this.handleReFresh" :status="info.status" :scrap_value="info.scrap_value" :is_scrap_value_show="is_scrap_value_show"/>
                    </dd>
                  </dl>
                </div>
                </Col>
                <Col :md="{ span: 5, offset: 0 }">
                  <div class="title" >
                    <h4>日志信息</h4>
                  </div>
                  <FlowLogs :logs = "info.logs" />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Card>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailOperateReleaseFlow } from '@/api/cmdb'
import FlowLogs from '../components/Logs'
import Approves from '../components/Approves'
// import { GetALLUsers } from '@/api/user'
// quill editor
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import * as cmdbRequestApi from '@/api/cmdb'
import { getJsonFun } from '@/libs/tools'

export default {
  components: {
    FlowLogs,
    Approves
  },
  data () {
    return {
      is_scrap_value_show: false,
      is_scrap_value_disabled: false,
      info: {},
      info_origin: {},
      infoError: false,
      all_user_list: [],
      moment: moment
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.infoTimer)
    this.infoTimer = null
  },
  mounted: function () {
    // this.getOrg(1)
  },
  methods: {
    actionChange (value) {
      console.log(value)
      if (value === '1') {
        this.info.approves = JSON.parse(JSON.stringify(this.info_origin.approves.filter(item => item.step !== '财务负责人')))
        console.log('无需财务负责人审批,审批完流程直接结束')
      } else {
        console.log(this.info_origin)
        this.info.approves = JSON.parse(JSON.stringify(this.info_origin.approves))
        console.log(this.info.approves)
      }
    },
    handleClick (item) {
      this.$Modal.info({
        width: '750px',
        title: item.asset_id,
        render: (h) => {
          return h('div', [
            h('json-viewer', {
              props: {
                value: getJsonFun(item.asset_info_dict),
                'expand-depth': 3,
                boxed: true
              },
              style: {
                width: '100%',
                height: '350px'
              }
            })
          ])
        }
      })
    },
    eventInput (value, instanceId) {
      console.log(value)
    },
    getOrg (id) {
      let params = {
        parentid: id
      }
      cmdbRequestApi.getWxOrgEmail(params).then(res => {
        console.log(res.data.result)
        if (id === 1) {
          this.options = res.data.result
        } else {
          return res.data.result
        }
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取公司组织列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取公司组织列表失败！服务器无响应'
          })
        }
      })
    },
    loadOptions ({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1
        }
        cmdbRequestApi.getWxOrgEmail(params).then(res => {
          parentNode.children = res.data.result
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取公司组织列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取公司组织列表失败！服务器无响应'
            })
          }
        })
      }
    },
    // 获取所有客服列表
    getAllUsersData () {
      this.all_user_list = []
      GetALLUsers().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 初始化
    init () {
      this.getData()
      // this.getAllUsersData()
    },
    // 获取工作流信息
    getData () {
      detailOperateReleaseFlow(this.$route.params.id).then(res => {
        this.info_origin = JSON.parse(JSON.stringify(res.data))
        this.info = res.data
        this.infoError = false
        if (this.info.status === 4 || this.info.status === 5) {
          // 判断当前审批到了财务负责人这一步
          if ((this.info.approves.filter(item => item.status === 'agree').length === 4 && this.info.type_name !== '研发测试设备') || (this.info.approves.filter(item => item.status === 'agree').length === 5 && this.info.type_name === '研发测试设备')) {
            // 根据当前登录人是否是财务这一步的审批人 判断是否显示残值选择框框
            if (this.info.approves.filter(item => item.step === '财务负责人' && item.can_approve === true && item.users.indexOf(this.$store.state.user.userName) > -1).length > 0) {
              this.is_scrap_value_show = true
              this.is_scrap_value_disabled = true
            } else {
              this.is_scrap_value_show = false
            }
          } else {
            // 审批没有流转到最后一步，把 approves 过滤掉最后一步 财务负责人,后面根据残值决定是否需要加进去
            this.info.approves = this.info_origin.approves.filter(item => item.step !== '财务负责人')
            // 判断当前审批到了财务这一步
            if ((this.info.approves.filter(item => item.status === 'agree').length === 3 && this.info.type_name !== '研发测试设备') || (this.info.approves.filter(item => item.status === 'agree').length === 4 && this.info.type_name === '研发测试设备')) {
              // 根据当前登录人是否是财务这一步的审批人 判断是否显示残值选择框框
              if (this.info.approves.filter(item => item.step === '财务' && item.can_approve === true && item.users.indexOf(this.$store.state.user.userName) > -1).length > 0) {
                this.is_scrap_value_show = true
                this.is_scrap_value_disabled = false
              } else {
                this.is_scrap_value_show = false
              }
            } else {
              this.is_scrap_value_show = false
            }
          }
        } else {
          if (this.info.scrap_value) {
            this.is_scrap_value_show = true
            this.is_scrap_value_disabled = true
          }
        }
      }).catch(res => {
        console.log(res.response)
        this.infoError = true
      })
    },
    // 处理刷新操作
    handleReFresh () {
      this.init()
    },
    cancelNotifyModal () {
      this.notifyForm = {
        notify_user: '',
        guide_address: ''
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .code-release-detail-describe {
    padding: 0;
    overflow-y: auto;
    max-height: 350px;
    padding-bottom: 5px;
    margin-top: 5px;
  }
  .code-release-detail-describe::-webkit-scrollbar {
    width: 5px;
  }
  .code-release-detail-describe::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .code-release-detail-describe::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  .code-release-notify-content {
    .ivu-form-item-content {
      line-height: unset !important;
    }
    .ql-snow.ql-toolbar {
      padding-top: unset !important;
      padding-bottom: unset !important;
    }
    .ql-toolbar.ql-snow {
      padding: unset;
    }
    .ql-formats {
      margin-top: 3px;
      margin-bottom: unset !important;
      button svg {
        width: unset !important;
        height: unset !important;
      }
    }
  }
  .code-release-notify-email {
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
